import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getSessionId() {
  let sid = sessionStorage.getItem("_it_sid");
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("_it_sid", sid);
  }
  return sid;
}

function getDeviceType() {
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

/**
 * Drop-in component — place inside <BrowserRouter>.
 * Fires a /api/analytics/pageview event on every storefront route change.
 * Admin routes are ignored server-side too, but we skip the request here.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin or login pages
    if (location.pathname.startsWith("/admin") || location.pathname === "/login") return;

    axios.post(`${API}/analytics/pageview`, {
      path: location.pathname,
      session_id: getSessionId(),
      device_type: getDeviceType(),
      referrer: document.referrer || "",
    }).catch(() => {}); // silent fail — never block UX
  }, [location.pathname]);

  return null; // renders nothing
}
